import { cx } from '@vizit/theme';
import type * as React from 'react';
import type { IconProps } from './types';

interface RefreshCw04IconProps extends IconProps {
  /**
   * Whether to animate the icon with a spinning animation
   *
   * @optional
   * @default false
   */
  animate?: boolean;
}

export const RefreshCw04Icon = (props: RefreshCw04IconProps & { ref?: React.Ref<SVGSVGElement> }) => {
  const { color = 'currentColor', size = 24, animate = false, className, ref, ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cx(animate && 'animate-spin', className)}
      ref={ref}
      {...rest}
    >
      <path
        d="M19.9688 6.3751H1.6875V12.9376M19.9688 6.3751L16.2187 2.625M19.9688 6.3751L16.2187 10.1252M7.78131 13.875L4.03125 17.6251M4.03125 17.6251L7.78131 21.3752M4.03125 17.6251H22.3125V11.0626"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
};
